import { PageWrapper } from "../page-wrapper";
import { Skeleton } from "../ui/skeleton";

interface TableSkeletonProps {
  title: string;
  description?: string;
  columns?: number;
  rows?: number;
  showActions?: boolean;
}

export function TableSkeleton({
  title,
  description,
  columns = 5,
  rows = 8,
  showActions = true,
}: TableSkeletonProps) {
  return (
    <PageWrapper
      action={
        showActions
          ? {
              label: "Loading...",
              onClick: () => {
                // Placeholder action for skeleton loading state
              },
              variant: "default",
            }
          : undefined
      }
      description={description}
      title={title}
    >
      <div className="space-y-4">
        {/* Search and filters */}
        <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <Skeleton className="h-10 w-full sm:w-64" />
          <div className="flex gap-2">
            <Skeleton className="h-10 w-24" />
            <Skeleton className="h-10 w-24" />
          </div>
        </div>

        {/* Table */}
        <div className="border-border bg-background overflow-hidden rounded-lg border">
          {/* Table header */}
          <div className="border-border bg-muted border-b px-6 py-3">
            <div className="flex gap-4">
              {Array.from({ length: columns }).map((_, i) => (
                <Skeleton
                  className="h-4 w-24"
                  key={`header-col-${i.toString()}`}
                />
              ))}
            </div>
          </div>

          {/* Table rows */}
          <div className="divide-fg-subtle divide-y">
            {Array.from({ length: rows }).map((_, i) => (
              <div className="px-6 py-4" key={`row-${i.toString()}`}>
                <div className="flex items-center gap-4">
                  {Array.from({ length: columns }).map((_col, j) => (
                    <Skeleton
                      className="h-4 flex-1"
                      key={`row-${i.toString()}-col-${j.toString()}`}
                    />
                  ))}
                </div>
              </div>
            ))}
          </div>

          {/* Pagination */}
          <div className="border-border border-t px-6 py-3">
            <div className="flex items-center justify-between">
              <Skeleton className="h-4 w-32" />
              <div className="flex gap-2">
                <Skeleton className="size-8" />
                <Skeleton className="size-8" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </PageWrapper>
  );
}
